// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1dfHL","choiceBoxes":"toolbarselects_choiceBoxes__2a8eV","simpleField":"toolbarselects_simpleField__7VE6Y"};